import { z } from "zod";

const userIdSchema = z.string().uuid();

export const userIdsSpecQueryParam = z.union([z.literal("all"), userIdSchema, z.array(userIdSchema)]);

export type OwnerIdsQueryParam = z.infer<typeof userIdsSpecQueryParam>;

// zod error shape, as passed on by @skilitics/express zodValidationErrorHandlingMiddleware
export const validationErrorSchema = z.object({
  issues: z.array(
    z
      .object({
        message: z.string(),
        path: z.array(z.string()).optional(),
      })
      .passthrough(),
  ),
});

export const expiringUrlSchema = z.object({
  url: z.string(),
  expires: z.date({ coerce: true }),
});

export type ExpiringUrlSchema = z.infer<typeof expiringUrlSchema>;

// @skilitics/designer-access
export const accessDenyCauseSchema = z.object({
  code: z.string(),
  plan: z.string().nullable(),
  state: z.string(),
  quota: z.number().optional(),
  requiredPlan: z.string().optional(),
});

export type AccessDeniedCause = z.infer<typeof accessDenyCauseSchema>;

export const featureAccessSchema = z.object({
  granted: z.boolean(),
  denyCause: accessDenyCauseSchema.nullable(),
});

export const accessDeniedErrorSchema = z.object({
  message: z.string(),
  cause: accessDenyCauseSchema,
});

export type AccessDeniedError = z.infer<typeof accessDeniedErrorSchema>;
